import React from 'react';
import filterProps from 'utils/filterProps';
import { BackgroundImg, FixedRatio } from 'elements/util';
import { ThumbnailBase } from './styled';

const Thumbnail = ({image, imageAlign, fixedRatio, compact, ...rest}) => {
  const dataAttrs = filterProps(rest, /^data-/);
  const img = (
    <BackgroundImg {...dataAttrs} src={image} alt='' align={imageAlign} />
  );
  return (
    <ThumbnailBase fixedRatio={fixedRatio} compact={compact}>
      {fixedRatio ? (
        <FixedRatio value={9/16}>
          {img}
        </FixedRatio>
      ) : img}
    </ThumbnailBase>
  );
};

export default Thumbnail;



// WEBPACK FOOTER //
// ./src/elements/Card/components/Thumbnail/Thumbnail.jsx